/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Password_Rule_Lower_CaseInputs */



/**
* | output |
* | --- |
* | "Password contains a lowercase letter (a-z)" |
*
* @param {Password_Rule_Lower_CaseInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const password_rule_lower_case = /** @type {((inputs?: Password_Rule_Lower_CaseInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Password_Rule_Lower_CaseInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Password contains a lowercase letter (a-z)")
	return /** @type {LocalizedString} */ ("Le mot de passe contient une minuscule (a-z)")
});